<template>
  <div class="contain">
    <div class="title">科目余额表</div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
      <!-- <el-col :span="6"> -->
        <el-form-item>
          <strong slot="label">月份</strong>
          <el-date-picker
            v-model="formInline.date"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="inquire"
            style="width:240px">
          </el-date-picker>
        </el-form-item>
      <!-- </el-col> -->
      <!-- <el-col :span="6">
        <el-form-item>
          <strong slot="label">月份</strong>
          <el-date-picker
            v-model="formInline.date"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="inquire">
          </el-date-picker>
        </el-form-item>
      </el-col> -->

      <el-form-item>
        <strong slot="label">账套</strong>
        <el-select v-model="formInline.accountType" placeholder="请选择账套" filterable @change="inquire">
          <el-option v-for="(item, index) in dropDown.subjectAccountType2" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <strong slot="label">科目类型</strong>
        <el-select v-model="formInline.subjectType" placeholder="请选择科目类型" filterable @change="inquire" clearable>
          <el-option v-for="(item, index) in dropDown.subjectType" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <strong slot="label">是否全部科目</strong>
        <el-select v-model="formInline.isAllSub" filterable @change="inquire">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-button icon="el-icon-download" type="warning" @click="doExport" size="mini">导出</el-button>
    </el-form>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
      v-loading="loading"
      border
      :height="tableHeight"
      row-key="subjectId"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="subjectNumber" label="科目编码" header-align="center"></el-table-column>
      <el-table-column prop="subjectName" label="科目名称" header-align="center">
        <!-- <temp slot-scope="scope">
          <a @click="handleDetail(scope.row)" class="link">{{scope.row.accountCode}}</a>
        </temp late> -->
      </el-table-column>
      <el-table-column label="期初余额" header-align="center">
        <el-table-column prop="startDebit" label="借方" align="right" header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.direction === '0'">{{(scope.row.startDebit - scope.row.startCredit) | comdify('no')}}</span>
            <span v-else-if="scope.row.direction === '1'"></span>
            <span v-else>{{scope.row.startDebit | comdify('no')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="startCredit" label="贷方" align="right" header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.direction === '1'">{{(scope.row.startCredit - scope.row.startDebit) | comdify('no')}}</span>
            <span v-else-if="scope.row.direction === '0'"></span>
            <span v-else>{{scope.row.startCredit | comdify('no')}}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="本期发生" header-align="center">
        <el-table-column prop="betweenDebit" label="借方" align="right" header-align="center">
          <template slot-scope="scope">
            {{scope.row.betweenDebit | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="betweenCredit" label="贷方" align="right" header-align="center">
          <template slot-scope="scope">
            {{scope.row.betweenCredit | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="期末余额" header-align="center">
        <el-table-column prop="endDebit" label="借方" align="right" header-align="center">
          <template slot-scope="scope">
            {{scope.row.endDebit | comdify('no')}}
          </template>
        </el-table-column>
        <el-table-column prop="endCredit" label="贷方" align="right" header-align="center">
          <template slot-scope="scope">
            {{scope.row.endCredit | comdify('no')}}
          </template>
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import url from '@/config/url'
import { mapState } from 'vuex'
import handleTree from '@/utils/handleTree'
import * as XLSX from "xlsx";
import FileSaver from 'file-saver'
  export default {
    computed: {
      ...mapState ({
        dropDown: state => state.dropDown.dropDown
      })
    },
    data() {
      return {
        tableData: [],
        loading: true,
        formInline: {
          date: [JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1))),
          JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)))],
          accountType: '1',
          subjectType: '',
          isAllSub: false,
          nbzzId:JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1,
        },
        tableHeight: window.innerHeight - 235
      }
    },
    created () {
      console.log("subSurplus")
      // 获取账套类型下拉
      if(!this.dropDown.subjectAccountType2){
        this.$http.get(url.getDataList, {params: {type: 'buss_subject_account_type'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setSubjectAccountType2', res.data.data)
          }
        })
      }
      // 获取科目类型下拉
      if(!this.dropDown.subjectType){
        this.$http.get(url.getDataList, {params: {type: 'buss_subject_type'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setSubjectType', res.data.data)
          }
        })
      }
      this.getList();
      // window.addEventListener('setItem', ()=> {
      //   // console.log(JSON.parse(sessionStorage.getItem('date')));
      //   this.formInline.date = [JSON.parse(sessionStorage.getItem('date')).name, JSON.parse(sessionStorage.getItem('date')).name]
      //   this.formInline.nbzzId = JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1
      //   this.getList()
      // })
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 235;
      })
      window.onresize = () => {   //屏幕尺寸变化就重新赋值
        return (() => {
          this.tableHeight = window.innerHeight - 235;
        })()
      }
    },
    methods: {
      getList() {
        this.tableData = []
        this.loading = true
        this.$http.get(url.accountBalanceTable, {params: {
          accountType: this.formInline.accountType,
          startDate: this.formInline.date ? this.formInline.date[0] : '',
          endDate: this.formInline.date ? this.formInline.date[1] : '',
          isAllSub: this.formInline.isAllSub,
          subjectType: this.formInline.subjectType,
            nbzzId:this.formInline.nbzzId
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            let length = res.data.data.detail.length
            // console.log(handleTree(res.data.data.detail[0], 'subjectId', 'pid'));
            // for(let i = 0;i < length; i ++) {
            //   res.data.data.detail[i] = handleTree(res.data.data.detail[i], 'subjectId', 'pid')
            //   res.data.data.detail[i].forEach(item => {
            //     this.tableData.push(item)
            //   });
            //   this.tableData.push(res.data.data.total[i])
            // }
            for(let i = 0;i < length; i ++) {
              this.tableData.push(res.data.data.total[i])
              res.data.data.detail[i] = handleTree(res.data.data.detail[i], 'subjectId', 'pid')
              res.data.data.detail[i].forEach(item => {
                this.tableData.push(item)
              });
            }
            this.tableData.push(res.data.data.count)
            // console.log(this.getOneArr(JSON.parse(JSON.stringify(this.tableData))));

          }
        })
      },
      getOneArr (data) {
        let newData = []
        const callback = (item) => {
          // console.log(JSON.parse(JSON.stringify(item)));
          // console.log(newData);

          newData.push(item);
          (item.children || (item.children = [])).map(v => {
            callback(v)
          })
          delete item.children
          // console.log(JSON.parse(JSON.stringify(item)));
          // newData.push(item)

          // newData.reverse()
        }
        data.map(v => callback(v))
        return newData
      },
      inquire() {
        this.getList()
      },
      doExport() {
        // 1. 定义多级表头结构
        const multiHeader = [
          ['科目编码', '科目名称', '期初余额','期初余额','本期发生', '本期发生', '期末余额', '期末余额'],  // 第一级表头
          ['', '', '借方', '贷方', '借方', '贷方', '借方', '贷方']  // 第二级表头
        ]

        // 2. 定义合并单元格区域
        const merges = [
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // A1:A2 科目编码
          { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // B1:B2 科目名称
          { s: { r: 0, c: 2 }, e: { r: 0, c: 3 } }, // C1:C2 期初余额
          { s: { r: 0, c: 4 }, e: { r: 0, c: 5 } }, // D1:D2 本期发生
          { s: { r: 0, c: 6 }, e: { r: 0, c: 7 } }, // E1:G1 期末余额
        ]
        const arr = this.getOneArr(JSON.parse(JSON.stringify(this.tableData)))
        const data = arr.map(item => [
          item.subjectNumber,
          item.subjectName,
          item.startDebit == 0 ? '' : item.startDebit,
          item.startCredit == 0 ? '' : item.startCredit ,
          item.betweenDebit == 0 ? '' : item.betweenDebit,
          item.betweenCredit == 0 ? '' : item.betweenCredit,
          item.endDebit == 0 ? '' : item.endDebit,
          item.endCredit == 0 ? '' : item.endCredit
        ])
        // 4. 合并表头和数据
        const wsData = [...multiHeader, ...data]

        // 5. 创建工作簿和工作表
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(wsData)

        // 6. 设置合并单元格
        ws['!merges'] = merges

        const colWidths =
          [
            { "wch": 12 },
            { "wch": 20 },
            { "wch": 12 },
            { "wch": 12 },
            { "wch": 12 },
            { "wch": 12 },
            { "wch": 12 },
            { "wch": 12 },
          ]
        ws['!cols'] = colWidths

        // 7. 导出Excel
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '科目余额表.xlsx')
      },
      testExport() {
        var wb = XLSX.utils.table_to_book(document.querySelector("#productTable"));
        let info = this.getSheetDimensions(wb['Sheets']['Sheet1'])
        wb['Sheets']['Sheet1']['!cols'] = Array.from({length: info.cols}, () => ({wch: 20}));
        wb['Sheets']['Sheet1']['!rows'] = Array.from({length: info.rows}, () => ({hpt: 20}));
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });

        try {
          // 使用 FileSaver 将二进制数据保存为文件
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            // 设置导出文件名称
            "product.xlsx"
          );
        } catch (e) {
          // 处理异常，例如在不支持 Blob 或 FileSaver 的情况下
          if (typeof console !== "undefined") console.log(e, wbout);
        }

      },
      getSheetDimensions(ws) {
        if (!ws || !ws['!ref']) {
          return { rows: 0, cols: 0 };
        }

        // 解析范围引用，如 "A1:D10"
        const range = XLSX.utils.decode_range(ws['!ref']);

        return {
          rows: range.e.r - range.s.r + 1,     // 行数
          cols: range.e.c - range.s.c + 1,     // 列数
          totalCells: (range.e.r - range.s.r + 1) * (range.e.c - range.s.c + 1),
          startRow: range.s.r + 1,             // 起始行号（1-based）
          startCol: range.s.c + 1,             // 起始列号（1-based）
          endRow: range.e.r + 1,               // 结束行号
          endCol: range.e.c + 1                // 结束列号
        };
      }
    },
  }
</script>

<style lang="scss" scoped>
.contain {
  padding: 16px;
  background-color: #fff;
  border-radius: 11px;
  height: 100%;
  box-sizing: border-box;
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 16px;
  }
}
</style>
